import {ValueObject} from '@s-ui/domain'

export class ModelInfoValueObject extends ValueObject {
  /**
   * @param {Object} modelInfo
   * */
}
